import '../App.css'
import logo from '../PB001b_ComedySeen_090723_logo_2.jpg'
import { Center, Image, Text, Container, Space, Grid, SimpleGrid, Divider, Card, List, Anchor } from '@mantine/core'
import Footer from '../components/Footer';
import Head from '../components/Head'
import profile from '../290591517_10109352142199085_172794176054360776_n.jpg';
import { IconGlobe, IconBuildingSkyscraper, IconFilePlus } from '@tabler/icons-react'
import CountUp from 'react-countup'





function LeaderboardPrizes25() {



    const links = [


        {
            "link": "/About",
            "label": "About"

        },
        {
            "link": "/Support",
            "label": "Support"

        },
        {
            "link": "/Pp",
            "label": "Privacy"

        },
        {
            "link": "/Tos",
            "label": "Terms of Use"

        },

    ]




    return (

        <body>

            <Head></Head>

            <Center>
                <Image src={logo} fit='contain' width={400}></Image>
            </Center>

            <Text ta='center' sx={{ fontSize: '3rem' }}>2025 Leaderboard Prizes</Text>



            <Space h='lg' />
            <Space h='lg' />
            <Space h='lg' />



            <Text ta='center' sx={{ fontSize: '2rem' }}>Comedians</Text>


            <Divider my="md" size='md' />

            <Center>

                <Card sx={{ background: '#d9ebf2' }}>


                    <SimpleGrid cols={2} spacing='xl'>
                        <div>

                            <Card sx={{ background: '#d9ebf2' }}>

                                <Center>
                                    <IconGlobe

                                        strokeWidth={2}
                                        color={'#532d86'} />

                                    <Text ta='center' td='underline'>Global</Text>
                                </Center>
                                <Space h='lg' />


                                <List


                                    spacing='xs'
                                    center>

                                    <Text fs='italic' fw={500} ta='center'>Top Comic</Text>
                                    <Space h='md' />

                                    <List.Item>First Place: $500</List.Item>
                                    <List.Item>Second Place: $400</List.Item>
                                    <List.Item>Third Place: $300</List.Item>



                                    <Space h='md' />


                                    <Text fs='italic' fw={500} ta='center'>Hardest Working Comic</Text>

                                    <List.Item>Winner: $100</List.Item>

                                    <Space h='md' />

                                    <Text fs='italic' fw={500} ta='center'>Top Open Mic</Text>

                                    <List.Item>First Place: $150</List.Item>
                                    <List.Item>Second Place: $100</List.Item>
                                    <List.Item>Third Place: $50</List.Item>
                                    <Space h='lg' />
                                    <Space h='lg' />

                                    <Text fs='italic' fw={500} ta='center'>Top Producer</Text>

                                    <List.Item>First Place: Match your marketing budget on 3 shows</List.Item>
                                    <List.Item>Second Place: Match your marketing budget on 2 shows</List.Item>
                                    <List.Item>Third Place: Match your marketing budget on 1 show</List.Item>

                                    <Space h='lg' />
                                    <Space h='lg' />




                                    <Text ta='center'>Presented by:</Text>
                                    <Center>
                                        <Image src={logo} maw={100}></Image>
                                    </Center>



                                </List>

                                <Space h='md' />






                            </Card>

                        </div>


                        <div>


                            <Card sx={{ background: "#d9ebf2" }}>

                                <Center>

                                    <IconBuildingSkyscraper
                                        strokeWidth={2}
                                        color={'#4dbf40'} />
                                    <Text ta='center' td='underline'>Brooklyn</Text>
                                </Center>
                                <Space h='lg' />
                                <Center>

                                    <List>
                                        <Text fs='italic' fw={500} ta='center'>Top Comic</Text>
                                        <List.Item>First Place: $150</List.Item>
                                        <List.Item>Second Place: $100</List.Item>
                                        <List.Item>Third Place: $50</List.Item>

                                        <Space h='lg' />
                                        <Space h='lg' />


                                        <Text ta='center'>Presented by:</Text>
                                        <Center>
                                            <Image src={logo} maw={100}></Image>
                                        </Center>

                                    </List>

                                </Center>

                                <br />

                                <Center>

                                    <IconBuildingSkyscraper
                                        strokeWidth={2}
                                        color={'#4dbf40'} />
                                    <Text ta='center' td='underline'>Miami</Text>
                                </Center>
                                <Space h='lg' />
                                <Center>

                                    <List>
                                        <Text fs='italic' fw={500} ta='center'>Top Comic</Text>
                                        <List.Item>First Place: 3 sets filmed and edited + headshot session</List.Item>
                                        <List.Item>Second Place: 2 sets filmed and edited + headshot session</List.Item>
                                        <List.Item>Third Place: 1 set filmed and edited + headshot session</List.Item>

                                        <Space h='lg' />
                                        <Space h='lg' />


                                        <Text ta='center'>Presented by:</Text>
                                        <Center>
                                            <Image src={logo} maw={100}></Image>
                                        </Center>

                                    </List>

                                </Center>

                            </Card>



                        </div>


                    </SimpleGrid>


                </Card>

            </Center>
            {/*
            <Center>
                <Text>
                    Cash prizes given directly to comedians since 2022:
                </Text>
            </Center>

            <Center>
                <Text size='xl' fw={700}>
                $
                <CountUp 
                end={3100}
                duration={15}/>
                </Text>
            </Center>
            */}

            <br />



            <Text ta='center' sx={{ fontSize: '2rem' }}>Fans</Text>

            <Divider my="md" size='md' />


            <Center>
                <Card sx={{ background: '#d9ebf2' }}>


                    <Center>
                        <IconGlobe
                            strokeWidth={2}
                            color={'#40bfbf'} />

                        <Text ta='center' td='underline'>Global</Text>

                    </Center>

                    <List>
                        <Text fs='italic' fw={500}>Top Fan</Text>
                        <List.Item>Top 3 winners: Pair of tickets to any stand up show (max $70 face value/ticket)</List.Item>

                    </List>





                </Card>







            </Center>
            <Space h='lg' />
            <Space h='lg' />
            <Space h='lg' />
            <Space h='lg' />
            <Space h='lg' />


            <Text ta='center' sx={{ fontSize: '2rem' }}>How To Earn Points</Text>

            <Divider my='md' size='md' />

            <SimpleGrid cols={3}>
                <div>

                    <Card sx={{ background: '#d9ebf2' }}>
                        <Text ta='center' td='underline'>Comedians and Fans</Text>
                        <br/>
                        <Text ta='center'>
                            +1 Submit a valid paid or free showcase<br/>
                            +2 Submit a valid open mic<br/>
                            +3 Report a valid dead Mic<br/>
                            +5 Rank your first comedian on your sense of humor profile<br/>
                            +10 Report a valid bug
                        </Text>
                    </Card>

                </div>
                <div>
                    <Card sx={{ background: '#d9ebf2' }}>
                        <Text ta='center' td='underline'>Comedians only</Text>
                        <br/>
                        <Text ta='center'>
                            +1 Check into an open mic or showcase<br/>
                            +1 Verified on stage by a fan or Comic<br/>
                            +3 Receive an upvote from a fan<br/>
                            +10 Receive an upvote from a new fan<br/>
                        </Text>
                    </Card>
                </div>
                <div>
                    <Card sx={{ background: '#d9ebf2' }}>
                        <Text ta='center' td='underline'>Fans only</Text>
                        <br/>
                        <Text ta='center'>
                            +1 Buy tickets to a showcase<br/>
                            +1 Complete post show verification and upvoting<br/>
                            +10 Check into an open mic<br/>
                        </Text>
                    </Card>

                </div>




            </SimpleGrid>





            <Footer links={links} />



        </body>




    )



}


export default LeaderboardPrizes25